import API from './api';

const USER_TOKEN = "USER_TOKEN";

const login = (form, resolve, reject) => {
	API.login(form).then((response) => {
		if (response.data.token !== undefined) {
			var token = response.data.token;
			userService.setToken(token).then(() => {
				resolve(true);
			});
		} else {
			reject(response.data);
		}
	}, (err) => {
		if (err === null) {
			reject("** An error occurred during the transaction");
		} else {
			reject(err);
		}
	});
};

const userService = {
	getToken: () => {
		return localStorage.getItem(USER_TOKEN);
	},
	setToken: (token) => {
		return new Promise((resolve, reject) => {
			//decrypt ton token, valide le et set tes datas dans le localStorage
			localStorage.setItem(USER_TOKEN, token);
			resolve();
		});
	},
	auth(email, password) {
		return new Promise((resolve, reject) => {
			var form = new FormData();
			form.append("email", email);
			form.append("password", password);
			form.append("type", 'INT');
			form.append("source", 'W');
			login(form, resolve, reject);
		});
	},
	authGG(email, accesstoken){
		return new Promise((resolve, reject) => {
			var form = new FormData();
			form.append("email", email);
			form.append("token", accesstoken);
			form.append("type", 'GG');
			form.append("source", 'W');
			login(form, resolve, reject);
		})
	},
	authFB(email, accesstoken){
		return new Promise((resolve, reject) => {
			var form = new FormData();
			form.append("email", email);
			form.append("token", accesstoken);
			form.append("type", 'FB');
			form.append("source", 'W');
			login(form, resolve, reject);
		})
	},
};



export { userService as default };



// WEBPACK FOOTER //
// ./src/services/userService.js